import Button from 'components/Button';
import { useTranslation } from 'react-i18next';
import { MAX_PUBLIC_TICKETS } from 'legacy/events/service';

interface AddTierButtonProps {
  sectionId: string;
  onAddTier: (sectionId: string) => void;
  productsLength: number;
}

const AddTierToCategoryButton: React.FC<AddTierButtonProps> = ({
  sectionId,
  onAddTier,
  productsLength
}) => {
  const { t } = useTranslation(['events']);
  
  return (
    <div className="mb-3 px-2">
      <Button
        variant="secondary"
        className="mt-0 text-base text-[#3853C4] bg-white font-semibold transition-transform active:scale-95"
        onClick={() => onAddTier(sectionId)}
        disabled={productsLength >= MAX_PUBLIC_TICKETS}
      >
        + {t('events:pricingTiers.buttons.addPublicTierToCategory')}
      </Button>
    </div>
  );
};

export default AddTierToCategoryButton;
